import type { ReactNode } from "react";

import ImageContainerBase from "~/components/shared/ImageContainer.jsx";
import { convertToPersianDate, getImage } from "~/utils/utils.jsx";

import type { UserInformation } from "../../types";
import ProfileCard from "../profile-card";
import ProfileImageContainer from "../profile-image-container";
import styles from "./profile-page.module.css";

const ImageContainer = ImageContainerBase as unknown as (props: Record<string, unknown>) => ReactNode;

type ProfilePageProps = {
  data: UserInformation;
};

const ProfilePage = ({ data }: ProfilePageProps) => {
  return (
    <div className={styles.page}>
      <div className={styles.banner}>
        <div className={styles.avatarWrap}>
          <ProfileImageContainer
            className={styles.avatar}
            src={getImage(data.profile_picture_preview) || undefined}
            width="150px"
            height="150px"
          />
        </div>
      </div>{" "}
      <div className={styles.fields}>
        <div className={styles.grid}>
          <div className={styles.cell}>
            <ProfileCard title="نام به فارسی" value={data.first_name_fa} />
          </div>
          <div className={styles.cell}>
            <ProfileCard title="نام به انگلیسی" value={data.first_name_en} />
          </div>
          <div className={styles.cell}>
            <ProfileCard title="نام خانوادگی به فارسی" value={data.last_name_fa} />
          </div>
          <div className={styles.cell}>
            <ProfileCard title="نام خانوادگی به انگلیسی" value={data.last_name_en} />
          </div>
          <div className={styles.cell}>
            <ProfileCard title="نام پدر به فارسی" value={data.father_name_fa} />
          </div>
          <div className={styles.cell}>
            <ProfileCard title="نام پدر به انگلیسی" value={data.father_name_en} />
          </div>
          {data.is_iranian ? (
            <div className={styles.cell}>
              <ProfileCard title="کدملی" value={data.national_code} />
            </div>
          ) : (
            <div className={styles.cell}>
              <ProfileCard title="کدفراگیر" value={data.foreign_pervasive_code} />
            </div>
          )}
          <div className={styles.cell}>
            <ProfileCard title="تاریخ تولد" value={convertToPersianDate(data.birthdate)} />
          </div>
          {!data.is_iranian && (
            <div className={styles.cell}>
              <ProfileCard title="تاریخ اعتبار گذرنامه" value={data.passport_expire_date} />
            </div>
          )}
          {!data.is_iranian && (
            <div className={styles.cell}>
              <ProfileCard title=" شماره گذرنامه" value={data.passport_number} />
            </div>
          )}
          <div className={styles.cellWide}>
            <ProfileCard title="ایمیل" value={data.email} />
          </div>
        </div>
        <hr />

        <div className={styles.documents}>
          <p className={styles.documentsTitle}>مدارک بارگذاری شده </p>
          {data.is_iranian ? (
            <div className={styles.docRow}>
              <div className={styles.docCol}>
                <p className={styles.docLabel}>کارت ملی</p>
                <ImageContainer
                  src={getImage(data.top_national_card_image_preview)}
                  width="150px"
                  heigh="150px"
                />
              </div>
              <div className={styles.docColGap}>
                <p className={styles.docLabel}> تصویرشناسنامه</p>
                <ImageContainer
                  src={getImage(data.first_birth_certificate_page_image_preview)}
                  width="150px"
                  heigh="150px"
                />
              </div>
            </div>
          ) : (
            <div className={styles.docColGap}>
              <p className={styles.docLabel}> پاسپورت</p>
              <ImageContainer src={getImage(data.passport_preview)} width="150px" heigh="150px" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
